Namespace.create("cv.Views.Setup").AppealView = Marionette.LayoutView.extend({
  template: cv.Templates["setup/appeal/view"],

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
    },
  ],

  regions: {
    region_appeal: "#region-appeal",
  },

  events: {},

  validation: {},

  templateHelpers: function () {
    return {};
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.listenTo(
      this,
      "form:saved",
      function () {
        vent.trigger("setup:next_screen");
      },
      this,
    );

    // If save button is clicked and it's valid, we copy over the draft to appeal
    this.listenTo(
      this,
      "form:validated",
      function () {
        this.trigger("form:set", "appeal", this._model_clone.get("draft"));
      },
      this,
    );

    console.log("SetupAppealView initialized.");
  },

  onShow: function () {
    // Default appeals
    var view = new cv.Views.VueComponentView({
      component: "BaseRichText",
      defaultArgs: {
        props: {
          name: "Enter content...",
          value: this._model_clone.get("draft"),
        },
      },
    });
    view.on(
      "value_changed",
      function (val) {
        this._model_clone.set("draft", val);

        // Save the draft
        $.ajax({
          url: this.model.url(),
          data: {
            draft: val,
          },
          dataType: "json",
          type: "PUT",
          success: _.bind(function (data) {}, this),
          error: _.bind(function (data) {}, this),
        });
      },
      this,
    );
    this.showChildView("region_appeal", view);

    /*
    this.showChildView('region_appeal', new cv.AppealEditorView({
      id : 'appeal',
      model : this._model_clone,
      enable_draft : true,
      draft_url : this.model.url()
    }));
    */

    // Change document title
    document.title = "Setup | Write your Fundraising Appeal";
  },
});
